import React from 'react';
import { HdButton, HdModal } from '../../../components';
import { AskSupportData } from '../../interfaces/askSupportTrigger';
import styles from './AskSupportDialog.module.scss';

export interface AskSupportDialogProps {
  open: boolean;
  data?: AskSupportData;
  onClose: (openSupport: boolean, data: AskSupportData) => void;
}

export function AskSupportDialog({ open, data, onClose }: AskSupportDialogProps) {
  return (
    <HdModal styling={{ width: '386px' }} open={open} onClose={() => onClose(false, data)}>
      <AskSupportDialogInner data={data} onClose={onClose} />
    </HdModal>
  );
}

export function AskSupportDialogInner(props: Omit<AskSupportDialogProps, 'open'>) {
  const onPositiveClick = () => {
    props.onClose(true, props.data);
  };

  return (
    <div className={`dialog-body ${styles.dialogBody}`}>
      <figure className={styles.supportExecutives}>
        <img src='https://res.cloudinary.com/hevo/image/upload/v1611139170/thumbnails/dashboard-support-executives_qcqkq7.png' />
      </figure>

      <h3 className={styles.concern}>{props.data.concern}</h3>

      <div className='d-flex align-items-start mt-7'>
        <HdButton dataId='' variation='flat' onClick={() => props.onClose(false, props.data)}>
          I'll fix it myself
        </HdButton>

        <div className='center-flex-col ml-4'>
          <HdButton dataId='' onClick={onPositiveClick}>
            Talk to Support
          </HdButton>

          <span className='text-secondary mt-2'>Get reply within seconds</span>
        </div>
      </div>
    </div>
  );
}
